import { useContext } from "react";
import { Button } from "@/components/ui/button";
import { ProviderImportContext } from "../../lib/provider-import-context";

export function ProviderImportAction({
  credentialId,
}: {
  credentialId: string | null;
}) {
  const imports = useContext(ProviderImportContext);
  const action = credentialId ? imports?.actions.get(credentialId) : undefined;
  if (!imports || !action) {
    return null;
  }
  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1">
      {action.pending && (
        <span className="text-xs font-medium text-blue-700">
          Provider update available
        </span>
      )}
      <Button
        type="button"
        variant="link"
        className="h-auto p-0 text-xs"
        onClick={() => imports.onReview(action.offerId)}
      >
        {action.pending ? "Review update" : "View provider version"}
      </Button>
    </div>
  );
}
